<template>
  <v-container v-if="Object.keys(pattern).length != 0" fluid>
    <v-layout row>
      <v-flex grow pa-3>
        <v-card>
          <v-list-item three-line>
            <v-list-item-avatar tile size="200">
              <v-img :src="logoData"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">{{
                pattern.R_NAME
              }}</v-list-item-title>
              <v-list-item-title class="headline mb-2">{{
                pattern.R_EVENT
              }}</v-list-item-title>
              <div class="overline mb-4">
                {{ pattern.R_ORG }} / {{ pattern.R_TTYPE }}
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- {{fields}} -->
    <v-layout row>
      <v-flex grow pa-3>
        <v-form ref="validationForm">
          <v-card>
            <v-card-title>{{ pattern.R_NAME }}</v-card-title>
            <v-card-text>
              <template v-for="(field, index) in fields">
                <v-row
                  v-if="field.R_FFIELD == 'EXT_NUM'"
                  :key="field.R_ID_TEMPL_FIELD"
                >
                  <v-text-field
                    v-model="field.value"
                    :key="field.R_ID_TEMPL_FIELD"
                    :label="field.R_NAME_EN ? field.R_NAME_EN : field.R_NAME"
                    class="shrink mx-3"
                    outlined
                    required
                    @keypress="onlyDigit"
                  ></v-text-field>

                  <v-btn class="pa-7" @click="loadFideData(index)"
                    >Загрузить данные из БД FIDE</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-row>

                <!-- R_TYPE == 1 - Тип "число" -->

                <v-text-field
                  v-else-if="field.R_TYPE == 1"
                  v-model="field.value"
                  :key="field.R_ID_TEMPL_FIELD"
                  :label="field.R_NAME_EN ? field.R_NAME_EN : field.R_NAME"
                  style="width: 300px"
                  outlined
                  required
                  @keypress="onlyDigit"
                  :rules="
                    parseInt(field.R_FFLAG, 0) & 1
                      ? [rules.required]
                      : []
                  "
                ></v-text-field>

                <!-- R_TYPE == 2 - Тип "дата" -->

                <v-card-text
                  v-else-if="field.R_TYPE == 2"
                  :key="field.R_ID_TEMPL_FIELD"
                  :style="
                    parseInt(field.R_FFLAG, 0) & 1 &&
                    field.value === null
                      ? 'color: #FF5252'
                      : ''
                  "
                >
                  {{ field.R_NAME_EN ? field.R_NAME_EN : field.R_NAME }}:<br />

                  <date-picker
                    v-model="field.value"
                    type="date"
                    format="DD.MM.YYYY"
                    value-type="format"
                    :label="field.R_NAME_EN ? field.R_NAME_EN : field.R_NAME"
                  >
                    <template #input="{ props, events }">
                      <input
                        v-bind="props"
                        v-on="{
                          ...events,
                          input: (event) =>
                            handleDateInput(event, events.input),
                        }"
                        :style="
                          parseInt(field.R_FFLAG, 0) & 1 &&
                          field.value === null
                            ? 'border: 2px solid #FF5252'
                            : ''
                        "
                      />
                    </template>
                  </date-picker>
                </v-card-text>

                <!-- R_TYPE == 3 - Тип "время" -->

                <v-card-text
                  v-else-if="field.R_TYPE == 3"
                  :key="field.R_ID_TEMPL_FIELD"
                  :style="
                    parseInt(field.R_FFLAG, 0) & 1 &&
                    field.value === null
                      ? 'color: #FF5252'
                      : ''
                  "
                >
                  {{ field.R_NAME_EN ? field.R_NAME_EN : field.R_NAME }}:<br />

                  <date-picker
                    v-model="field.value"
                    type="time"
                    format="HH:mm"
                    placeholder="00:00"
                    :label="field.R_NAME_EN ? field.R_NAME_EN : field.R_NAME"
                    :rules="
                      parseInt(field.R_FFLAG, 0) & 1
                        ? [rules.required]
                        : []
                    "
                  >
                    <template #input="{ props, events }">
                      <input
                        v-bind="props"
                        v-on="{
                          ...events,
                          input: (event) =>
                            handleTimeInput(event, events.input),
                        }"
                        :style="
                          parseInt(field.R_FFLAG, 0) & 1 &&
                          field.value === null
                            ? 'border: 2px solid #FF5252'
                            : ''
                        "
                      />
                    </template>

                    <i slot="icon-calendar"
                      ><v-icon>mdi-clock-outline</v-icon></i
                    >
                  </date-picker>
                </v-card-text>

                <!-- R_TYPE == 4 - Тип "дата/время" -->

                <v-card-text
                  v-else-if="field.R_TYPE == 4"
                  :key="field.R_ID_TEMPL_FIELD"
                  :style="
                    parseInt(field.R_FFLAG, 0) & 1 &&
                    field.value === null
                      ? 'color: #FF5252'
                      : ''
                  "
                >
                  {{ field.R_NAME_EN ? field.R_NAME_EN : field.R_NAME }}:<br />
                  <date-picker
                    v-model="field.value"
                    type="datetime"
                    format="DD.MM.YYYY HH:mm"
                    :label="field.R_NAME_EN"
                    :rules="
                      parseInt(field.R_FFLAG, 0) & 1
                        ? [rules.required]
                        : []
                    "
                  >
                    <template #input="{ props, events }">
                      <input
                        v-bind="props"
                        v-on="{
                          ...events,
                          input: (event) =>
                            handleDateTimeInput(event, events.input),
                        }"
                        :style="
                          parseInt(field.R_FFLAG, 0) & 1 &&
                          field.value === null
                            ? 'border: 2px solid #FF5252'
                            : ''
                        "
                      />
                    </template>

                    <i slot="icon-calendar"
                      ><v-icon>mdi-calendar-clock</v-icon></i
                    >
                  </date-picker>
                </v-card-text>

                <!-- R_TYPE == 6 - Тип "ComboBox" -->
                <v-combobox
                  v-else-if="field.R_TYPE == 6"
                  v-model="field.value"
                  :key="field.R_ID_TEMPL_FIELD"
                  :label="field.R_NAME_EN ? field.R_NAME_EN : field.R_NAME"
                  :items="field.R_SQL_RESULT"
                  item-value="ID"
                  item-text="NAME"
                  :style="field.R_STRETCH == 1 ? '' : 'width: 300px'"
                  outlined
                  :rules="
                    parseInt(field.R_FFLAG, 0) & 1
                      ? [rules.required]
                      : []
                  "
                ></v-combobox>

                <!-- R_STRETCH == 0 - без растяжения-->

                <v-text-field
                  v-else-if="field.R_STRETCH == 0"
                  v-model="field.value"
                  :key="field.R_ID_TEMPL_FIELD"
                  :label="field.R_NAME_EN ? field.R_NAME_EN : field.R_NAME"
                  style="width: 300px"
                  outlined
                  required
                  v-on:blur="onChangeTextField(field)"
                  :rules="
                    parseInt(field.R_FFLAG, 0) & 1
                      ? [rules.required]
                      : []
                  "
                ></v-text-field>

                <!-- R_STRETCH == 1 - растяжение по горизонтали -->

                <v-text-field
                  v-else-if="field.R_STRETCH == 1"
                  v-model="field.value"
                  :key="field.R_ID_TEMPL_FIELD"
                  :label="field.R_NAME_EN ? field.R_NAME_EN : field.R_NAME"
                  outlined
                  required
                  v-on:blur="onChangeTextField(field)"
                  :rules="
                    parseInt(field.R_FFLAG, 0) & 1
                      ? [rules.required]
                      : []
                  "
                ></v-text-field>

                <!-- "R_FFIELD": "FANID" -->

                <!-- <v-textarea
                v-else
                v-model="field.value"
                :key="field.R_ID_TEMPL_FIELD"
                :label="field.R_NAME_EN ? field.R_NAME_EN : field.R_NAME"
                outlined
                required
              ></v-textarea> -->
              </template>

              <!-- R_FFLAG == 2-й бит - load file (*.jpg/*.jpeg). Photo -->

              <v-list-item v-if="parseInt(pattern.R_FFLAG, 0) & 2">
                <v-container fluid>
                  <v-row>
                    <v-col cols="auto">
                      <v-list-item-avatar
                        tile
                        size="300"
                        style="border: 1px solid black"
                      >
                        <cropper
                          ref="cropper"
                          class="cropper"
                          :src="uploadFileDataBase64"
                          :stencil-props="{
                            aspectRatio:
                              aspectRatio == undefined ? null : aspectRatio,
                          }"
                        ></cropper>
                      </v-list-item-avatar>
                    </v-col>

                    <v-col cols="auto">
                      <v-row>
                        <input
                          type="file"
                          ref="fileInput"
                          style="display: none"
                          accept=".jpg,.jpeg,.png"
                          @input="onSelectFile"
                          :key="key1"
                        />
                        <v-btn
                          class="ma-2 pa-6"
                          @click="$refs.fileInput.click()"
                          >Загрузить фото с диска</v-btn
                        >
                      </v-row>
                      <v-row v-if="!noCamera">
                        <v-btn class="ma-2 pa-6" @click="showCameraDialog()"
                          >Загрузить фото с камеры</v-btn
                        >
                      </v-row>
                      <v-row>
                        <v-btn class="ma-2 pa-6" @click="clearFile()"
                          >Удалить фото</v-btn
                        >
                      </v-row>
                    </v-col>

                    <v-col />
                  </v-row>
                </v-container>
              </v-list-item>

              <!-- R_FFLAG == 3-й бит - load file (*.jpg/*.jpeg). Passport scan -->

              <v-list-item v-if="parseInt(pattern.R_FFLAG, 0) & 4">
                <v-container fluid>
                  <v-row>
                    <v-col cols="auto">
                      <v-list-item-avatar
                        tile
                        size="300"
                        style="border: 1px solid black"
                      >
                        <cropper
                          ref="passportCropper"
                          class="cropper"
                          :src="uploadPassportDataBase64"
                        ></cropper>
                      </v-list-item-avatar>
                    </v-col>

                    <v-col cols="auto">
                      <v-row>
                        <input
                          type="file"
                          ref="passportFileInput"
                          style="display: none"
                          accept=".jpg,.jpeg,.png"
                          @input="onSelectPassportFile"
                          :key="key2"
                        />
                        <v-btn
                          class="ma-2 pa-6"
                          @click="$refs.passportFileInput.click()"
                          >Загрузить скан паспорта с диска</v-btn
                        >
                      </v-row>
                      <v-row>
                        <v-btn class="ma-2 pa-6" @click="clearPassportFile()"
                          >Удалить скан паспорта</v-btn
                        >
                      </v-row>
                    </v-col>

                    <v-col />
                  </v-row>
                </v-container>
              </v-list-item>

              <!-- R_FFLAG == 4-й бит - Согласие на обработку персональной информации -->

              <v-container fluid v-if="parseInt(pattern.R_FFLAG, 0) & 8">
                <v-checkbox v-model="persDataFlag">
                  <template v-slot:label
                    ><div>
                      Согласие на обработку персональных данных
                    </div></template
                  >
                </v-checkbox>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-container fluid>
                <v-row justify="center">
                  <v-btn
                    class="ma-2 pa-6"
                    color="success"
                    :disabled="!enableCreateCard"
                    @click="createRequest"
                    >Оформить заявку</v-btn
                  >
                  <v-btn
                    :disabled="false"
                    class="ma-2 pa-6"
                    color="warning"
                    @click="clearRequest"
                    >Очистить заявку</v-btn
                  >
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>

    <div>
      <camera-dialog
        :visible="cameraDialogVisibility"
        @close="cameraDialogVisibility = false"
        @captured-camera-photo="getCameraPhoto"
      >
      </camera-dialog>
    </div>
  </v-container>
</template>

<script>
//const config = require("@/config.json");

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/ru";

import CameraDialog from "@/components/CameraDialog";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
// var format = require("date-format");

// var atob = require("atob");

import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  name: "PatternCard",

  props: {
    pattern: Object,
    patternLogo: String,
    fields: Array,
  },

  watch: {
    pattern: function () {
      // this.uploadFile = null;
      // this.cameraDialogVisibility = false;
      // Закомментируем нижние строки, чтобы фото сохранялось при смене шаблона
      //      this.uploadFileData = null;
      //      this.uploadFileDataBase64 = null;
    },
  },

  components: {
    // Camera,
    DatePicker,
    CameraDialog,
    Cropper,
  },

  data: () => ({
    // uploadFile: null,
    uploadFileData: null,
    uploadFileDataBase64: null,
    cameraDialogVisibility: false,

    uploadPassportData: null,
    uploadPassportDataBase64: null,
    persDataFlag: false,

    aspectRatio: window.__env.aspectRatio, //config.aspectRatio,
    key1: 0,
    key2: 0,

    rules: {
      required: (value) => !!value || "", // !!value || "Поле необходимое для заполнения",
      // required: (value) => !!value || "Поле необходимое для заполнения",
    },
  }),

  computed: {
    logoData() {
      return `data:image/jpeg;base64, ${this.patternLogo}`;
    },

    // uploadFileDataBase64() {
    //   return `data:image/jpeg;base64, ${btoa(this.uploadFileData)}`;
    // },

    enableCreateCard() {
      const found = this.fields.find(
        (field) =>
          parseInt(field.R_FFLAG, 0) & 1 &&
          (field.value == null || field.value === "")
      );

      if (found !== undefined) return false;

      if (parseInt(this.pattern.R_FFLAG, 0) & 2) {
        if (!this.uploadFileDataBase64) return false;
      }

      if (parseInt(this.pattern.R_FFLAG, 0) & 8) {
        if (!this.persDataFlag) return false;
      }

      return true;
    },

    ...mapGetters({
      userId: "account/userId",
      noCamera: "account/noCamera",
      patternId: "patterns/selectedIndex",
      isIndividual: "account/isIndividual", // true - индивидуальный пользователь, false - групповой пользователь
    }),
  },

  methods: {
    handleDateInput(event, update) {
      let value = event.target.value.replace(/[^0-9]/g, "");

      if (value.length >= 3)
        value = value.substring(0, 2) + "." + value.substring(2);

      if (value.length >= 6)
        value = value.substring(0, 5) + "." + value.substring(5);

      if (value.length > 10) value = value.substring(0, 10);

      this.$forceUpdate();
      update(value);
    },

    handleTimeInput(event, update) {
      let value = event.target.value.replace(/[^0-9]/g, "");

      if (value.length >= 3)
        value = value.substring(0, 2) + ":" + value.substring(2);

      if (value.length > 5) value = value.substring(0, 5);

      this.$forceUpdate();
      update(value);
    },

    handleDateTimeInput(event, update) {
      let value = event.target.value.replace(/[^0-9]/g, "");

      if (value.length >= 3)
        value = value.substring(0, 2) + "." + value.substring(2);

      if (value.length >= 6)
        value = value.substring(0, 5) + "." + value.substring(5);

      if (value.length >= 11)
        value = value.substring(0, 10) + " " + value.substring(10);

      if (value.length >= 14)
        value = value.substring(0, 13) + ":" + value.substring(13);

      if (value.length > 16) value = value.substring(0, 16);

      this.$forceUpdate();
      update(value);
    },

    getCameraPhoto: function (value) {
      this.uploadFileDataBase64 = value;
    },

    // ...mapActions({
    //   CreateCard: "patterns/CreateCard",
    //   AddCardField: "patterns/AddCardField",
    // }),

    ...mapActions("patterns", [
      "AddCardField",
      "CreateCard",
      "GetFideInfo",
      "GetPkInfo",
      "GetFideAPIData",
    ]),
    ...mapActions("account", ["StartLoading", "StopLoading"]),

    // change({ coordinates, canvas }) {
    //   console.log(coordinates, canvas);
    // },

    onSelectFile() {
      this.key1 = this.key1 + 1; // ...чтобы перерисовал фото

      const input = this.$refs.fileInput;
      const files = input.files;

      if (files && files[0]) {
        var file = files[0];

        if (file.size > 4194304) {
          this.$fire({
            text: "Выбран файл недопустимо большого размера. Заявка с таким файлом не может быть оформлена",
            type: "error",
          }).then(() => {
            // this.uploadFile = null;
            // this.uploadFileData = null;
            // this.uploadFileDataBase64 = null;
          });
        } else {
          var reader = new FileReader();

          reader.addEventListener(
            "load",
            function () {
              this.uploadFileData = reader.result;
              this.uploadFileDataBase64 = `data:image/jpeg;base64, ${btoa(
                reader.result
              )}`;
            }.bind(this),
            false
          );

          reader.readAsBinaryString(file);
        }
      }
    },

    onSelectPassportFile() {
      this.key2 = this.key2 + 1; // ...чтобы перерисовал фото

      const input = this.$refs.passportFileInput;
      const files = input.files;

      if (files && files[0]) {
        var file = files[0];

        if (file.size > 4194304) {
          this.$fire({
            text: "Выбран файл недопустимо большого размера. Заявка с таким файлом не может быть оформлена",
            type: "error",
          }).then(() => {
            // this.uploadFile = null;
            // this.uploadFileData = null;
            // this.uploadFileDataBase64 = null;
          });
        } else {
          var reader = new FileReader();

          reader.addEventListener(
            "load",
            function () {
              this.uploadPassportData = reader.result;
              this.uploadPassportDataBase64 = `data:image/jpeg;base64, ${btoa(
                reader.result
              )}`;
            }.bind(this),
            false
          );

          reader.readAsBinaryString(file);
        }
      }
    },

    clearFile() {
      // this.uploadFile = null;
      this.uploadFileData = null;
      this.uploadFileDataBase64 = null;
      this.key1 = this.key1 + 1; // ...чтобы перерисовал фото
    },

    clearPassportFile() {
      // this.uploadPassportFile = null;
      this.uploadPassportData = null;
      this.uploadPassportDataBase64 = null;
      this.key2 = this.key2 + 1; // ...чтобы перерисовал скан паспорта
    },

    showCameraDialog() {
      this.key1 = this.key1 + 1; // ...чтобы перерисовал фото
      this.cameraDialogVisibility = true;
    },

    clearRequest() {
      // this.uploadFile = null;
      this.uploadFileData = null;
      this.uploadFileDataBase64 = null;
      this.key1 = this.key1 + 1; // ...чтобы перерисовал фото

      this.uploadPassportData = null;
      this.uploadPassportDataBase64 = null;
      this.key2 = this.key2 + 1; // ...чтобы перерисовал скан паспорта

      this.persDataFlag = false;

      for (var field of this.fields) {
        field.value = null;
      }
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join(".");
    },

    async loadFideData(index) {
      const field_F = this.fields.find(
        (el) => el.R_FFIELD == "F" || el.R_FFIELD == "F_LAT"
      );
      const field_I = this.fields.find(
        (el) => el.R_FFIELD == "I" || el.R_FFIELD == "I_LAT"
      );

      if (field_F) field_F.value = null;
      if (field_I) field_I.value = null;

      this.GetFideInfo(this.fields[index].value)
        .then((result) => {
          const res = result.result;

          if (res) {
            if (Array.isArray(res)) {
              if (res.length > 0) {
                const rec = res[0];
                if (field_F) field_F.value = rec["R_F"];
                if (field_I) field_I.value = rec["R_NAME"];
              }
            }
          }

          return true;
        })
        .then(() => {
          return this.GetFideAPIData(this.fields[index].value);
        })
        .then((result) => {
          const res = result.result;

          if (res) {
            if (res.name) {
              const nameArray = res.name.split(",");
              if (nameArray.length > 0) {
                if (!field_F.value) {
                  field_F.value = nameArray[0].trim();
                }
              }

              if (nameArray.length > 1) {
                if (!field_I.value) {
                  field_I.value = nameArray[1].trim();
                }
              }
            }

            if (res.image_file) {
              this.uploadFileDataBase64 = res.image_file.image_file;
            } else {
              this.uploadFileDataBase64 = null;
            }
          }
        })
        .catch((err) => {
          this.$fire({
            text: err.toString(),
            type: "error",
          });
        });
    },

    async createCardRequest(userId, patternId, photo, passport, agreement) {
      var cardId = null;

      this.StartLoading();

      this.CreateCard({
        userId: userId,
        patternId: patternId,
        photo: photo,
        passport: passport,
        agreement: agreement,
      })
        .then(async (result) => {
          if (result.error == null) {
            cardId = result.result[0].R_ID_CARD;
            // console.log("fields", this.fields);
            for (var field of this.fields) {
              var fieldValue = field.value;

              // console.log("fieldValue", fieldValue);
              // console.log("field.R_TYPE", field.R_TYPE);

              if (field.R_TYPE == 2) {
                // дата
                //                 const tmpValue = new Date(fieldValue);
                // console.log("tmpValue", tmpValue);
                //                 if (isNaN(tmpValue)) {
                //                   fieldValue = null;
                //                 } else {
                //                   fieldValue = format.asString("dd.MM.yyyy", tmpValue);
                //                 }
                // console.log("New fieldValue", fieldValue);
              } else if (field.R_TYPE == 3) {
                // время
                // const tmpValue = new Date(fieldValue);
                // if (isNaN(tmpValue)) {
                //   fieldValue = null;
                // } else {
                //   fieldValue = format.asString("hh:mm", tmpValue);
                // }
              } else if (field.R_TYPE == 4) {
                // дата/время
                // const tmpValue = new Date(fieldValue);
                // if (isNaN(tmpValue)) {
                //   fieldValue = null;
                // } else {
                //   fieldValue = format.asString("dd.MM.yyyy hh:mm", tmpValue);
                // }
              } else if (field.R_TYPE == 6) {
                // ComboBox
                fieldValue = field.value.ID;
              }

              // console.log("call AddCardField", {
              //   cardId: cardId,
              //   fieldName: field.R_FFIELD,
              //   fieldValue: fieldValue,
              // });

              await this.AddCardField({
                cardId: cardId,
                fieldName: field.R_FFIELD,
                fieldValue: fieldValue,
              });
            }
          } else {
            this.$fire({
              text: result.error,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.$fire({
            text: err.toString(),
            type: "error",
          });
        })
        .finally(() => {
          this.StopLoading();
          if (cardId != null) {
            // if (this.isIndividual) {
            this.$fire({
              text: "Заявка создана. Номер заявки: " + cardId,
              type: "success",
            }).then(() => {
              this.clearRequest();
            });
            // }
            // else{
            //   this.clearRequest();
            // }
          }
        });
    },

    async createRequest() {
      /*      
      if (parseInt(this.pattern.R_FFLAG, 0) & 2) {
        const { canvas } = this.$refs.cropper.getResult();

        if (canvas != undefined) {
          canvas.toBlob((result) => {
            this.createCardRequest(this.userId, this.patternId, result);
          }, "image/jpeg");
        } else {
          this.$fire({
            text: "Для оформления заявки необходимо загрузить фото",
            type: "error",
          });
        }
      } else {
        this.createCardRequest(this.userId, this.patternId, null);
      }
*/

      // for (var field of this.fields) {
      //   if (field.value === null || field.value === undefined || field.toString == '') {
      //     this.$fire({
      //       text: "Для оформления заявки необходимо заполнить все поля",
      //       type: "error",
      //     });

      //     return;
      //   }
      // }

      var _this = this;

      Promise.all([
        new Promise(function (resolve /*, reject*/) {
          if (parseInt(_this.pattern.R_FFLAG, 0) & 2) {
            const { canvas } = _this.$refs.cropper.getResult();

            if (canvas != undefined) {
              canvas.toBlob((result) => {
                // console.log("Фото обработано", result.size);
                resolve({ res: result.size, data: result });
              }, "image/jpeg");
            } else {
              _this.$fire({
                text: "Для оформления заявки необходимо загрузить фото",
                type: "error",
              });
              resolve({ res: -1, data: null });
            }
          } else {
            resolve({ res: 0, data: null });
          }
        }),
        new Promise(function (resolve /*, reject*/) {
          if (parseInt(_this.pattern.R_FFLAG, 0) & 4) {
            const { canvas } = _this.$refs.passportCropper.getResult();

            if (canvas != undefined) {
              canvas.toBlob((result) => {
                // console.log("Скан паспорта обработан", result.size);
                resolve({ res: result.size, data: result });
              }, "image/jpeg");
            } else {
              _this.$fire({
                text: "Для оформления заявки необходимо загрузить скан паспорта",
                type: "error",
              });
              resolve({ res: -1, data: null });
            }
          } else {
            resolve({ res: 0, data: null });
          }
        }),
      ])
        .then((result) => {
          if (result.length >= 2) {
            if (result[0].res < 0 && result[1].res < 0) {
              _this.$fire({
                text: "Для оформления заявки необходимо загрузить фото и скан паспорта",
                type: "error",
              });
            } else if (result[0].res < 0) {
              _this.$fire({
                text: "Для оформления заявки необходимо загрузить фото",
                type: "error",
              });
            } else if (result[1].res < 0) {
              _this.$fire({
                text: "Для оформления заявки необходимо загрузить скан паспорта",
                type: "error",
              });
            } else {
              this.createCardRequest(
                this.userId,
                this.patternId,
                result[0].data,
                result[1].data,
                this.persDataFlag ? 1 : 0
              );
            }
          }

          // console.log("RESULT", result);
        })
        .catch((err) => {
          _this.$fire({
            text: err,
            type: "error",
          });
        });
    },

    onlyDigit($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      } else if ($event.target.value == "0") {
        $event.target.value = "";
      }
    },

    // отслежиивание потери фокуса полем ввода
    onChangeTextField(field) {
      // если вводится №ПК, то подтягиваем данные из БД
      if (field.R_FFIELD === "FANID") {
        this.loadPKData(field.value);
      }
    },

    async loadPKData(n_pk) {
      const field_F = this.fields.find((el) => el.R_FFIELD == "F");

      const field_I = this.fields.find((el) => el.R_FFIELD == "I");

      const field_O = this.fields.find((el) => el.R_FFIELD == "O");

      const field_PHONE = this.fields.find((el) => el.R_FFIELD == "PHONE");

      const field_E_MAIL = this.fields.find((el) => el.R_FFIELD == "E_MAIL");

      const field_DATE_BIRTH = this.fields.find(
        (el) => el.R_FFIELD == "DATE_BIRTH"
      );

      this.GetPkInfo(n_pk)
        .then((result) => {
          const res = result.result;
          //console.log(res)
          if (res) {
            if (Array.isArray(res)) {
              if (res.length > 0) {
                const rec = res[0];
                if (field_F) field_F.value = rec["R_F"];
                if (field_I) field_I.value = rec["R_I"];
                if (field_O) field_O.value = rec["R_O"];
                if (field_PHONE) field_PHONE.value = rec["R_PHONE"];
                if (field_E_MAIL) field_E_MAIL.value = rec["R_E_MAIL"];
                if (field_DATE_BIRTH)
                  field_DATE_BIRTH.value = rec["R_DATE_BIRTH"];
              }
            }
          }

          return true;
        })
        .catch((err) => {
          this.$fire({
            text: err.toString(),
            type: "error",
          });
        });
    },
  },

  // mounted() {
  //   this.$nextTick(function () {
  //     this.$refs.validationForm.validate();
  //   });
  // },

  updated: function () {
    this.$refs.validationForm.validate();
  },
};
</script>

<style>
/* .date-picker-red-border {
  border: none !important;
  border: 1px solid #F00 !important;
} */
</style>

<style scoped>
.mx-datepicker {
  margin-top: 0px;
  left: -14px;
  margin-bottom: 20px;
  padding: 0px;
  height: 58px;
}
.mx-input {
  height: 58px;
}
</style>
